import actionCable from 'actioncable';
import buildCableUrl from './lib/buildCableUrl';

const cable = actionCable.createConsumer(buildCableUrl());

export default cable;
